import * as types from "./actionTypes";

//********** CONTRACT SIGNING *************/
export const showContractSigning = (show, callback = null) => ({
  type: types.SHOW_CONTRACT_SIGNING,
  payload: {show, callback}
});

export const setAfterContractSignCallback = (afterContractSignCallback) => ({
  type: types.SET_AFTER_CONTRACT_SIGN_CALLBACK,
  payload: {afterContractSignCallback}
});

export const contractSignPostSignature = (contractSignData) => ({
  type: types.CONTRACT_SIGNING_POST_SIGNATURE,
  payload: contractSignData
});

export const showSignaturePad = (show, tag) => ({
  type: types.CONTRACT_SIGNING_SHOW_SIGNATURE_PAD,
  payload: {show, tag}
});

export const setContractsValues = ({contractId, pageIndex, fieldIndex, name, value}) => {
  return (dispatch, getState) => {
    let {contractsValues} = getState().contractSigningState;
    if (!contractId) {
      return
    }
    if (!contractsValues[contractId]) {
      contractsValues[contractId] = {}
    }
    if (!contractsValues[contractId][pageIndex]) {
      contractsValues[contractId][pageIndex] = {}
    }
    contractsValues[contractId][pageIndex][fieldIndex] = {name, value};
    dispatch({
      type: types.CONTRACT_SIGNING_SET_CONTRACTS_VALUES,
      payload: {
        contractsValues: {...contractsValues}
      }
    })
  }
};

export const setContractSigningStep = step => ({
  type: types.CONTRACT_SIGNING_SET_STEP,
  payload: {step}
});

export const setContractDocumentForJob = (documentData) => ({
  type: types.CONTRACT_SIGNING_JOB_DOCUMENT,
  payload: {...documentData}
});

export const setContractBlob = (contractBlob) => ({
  type: types.SET_CONTRACT_BLOB,
  payload: {contractBlob}
});

export const restoreContractValues = (pagesCustomFieldsValue, savedInvoiceNumberOfPages, needToUpdateContract, contractsValues = {}) => ({
  type: types.CONTRACT_SIGNING_RESTORE_VALUES,
  payload: {pagesCustomFieldsValue, savedInvoiceNumberOfPages, needToUpdateContract, contractsValues}
});

export const setContractsList = (contractsList) => ({
  type: types.CONTRACT_SIGNING_SET_CONTRACTS_LIST,
  payload: {contractsList}
});
